var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no"},[_c('img',{attrs:{"src":require("../../assets/State/no.png"),"alt":""}}),_c('p',[_vm._v(" 哎呀，网络已走丢"),_c('br'),_vm._v(" 您可以尝试"),_c('span',{on:{"click":_vm.link}},[_vm._v("刷新数据")])])])}
var staticRenderFns = []

export { render, staticRenderFns }